import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { BlockedPeriodListItem } from '../../features/blockedPeriods/blockedPeriodsSlice';
import { BlockedPeriodDetails } from '../../features/blockedPeriods/blockedPeriodDetailsSlice';

export interface BlockedPeriodsByAccommodationResponse {
  data: BlockedPeriodListItem[];
}

const blockedPeriodsService = {
  getBlockedPeriodsByAccommodation: async (
    accommodationId: string,
  ): Promise<BlockedPeriodsByAccommodationResponse> => {
    const params = { accommodationId };
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params,
    };

    const response = await axios.get<BlockedPeriodsByAccommodationResponse>(
      `/pricing/blockedperiods/getBlockedPeriodsByAccommodation`,
      config,
    );
    return response.data;
  },
  getBlockedPeriodDetails: async (blockedPeriodId: string) => {
    const params = { blockedPeriodId };
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params,
    };

    const response = await axios.get<BlockedPeriodDetails>(
      `/pricing/blockedperiods/getDetails`,
      config,
    );
    return response.data;
  },
  saveOrUpdateBlockedPeriod: async (request: BlockedPeriodDetails) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      `/pricing/blockedperiods/saveOrUpdate`,
      request,
      config,
    );
    return response.data;
  },
  deleteBlockedPeriod: async (blockedPeriodId: string) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { blockedPeriodId },
    };

    const response = await axios.delete(
      `/pricing/blockedperiods/delete`,
      config,
    );
    return response.data;
  },
};

export default blockedPeriodsService;
